import React from "react";
import ModalConfirmarInfoPersonal from "../../../componentesEspeciales/cuenta/modalConfirmarInfo";


function InfoBancaria({ usuario, infoBanco, bancos, cambiarCampoBanco, guardarPerfil, }) {


    return (
        <>
            {/* TITULO Y BOTONES INFORMACIÓN BANCARIA */}
            <div className="d-flex justify-content-between align-items-center flex-wrap gap-2 mb-3">
                <h2 className="mb-0">Información bancaria</h2>
                <div className="d-flex gap-2">
                    {/* BOTÓN GUARDAR */}
                    {usuario?.infoBancariaCompleta ? null : (
                        <button
                            className="btn btn-primary"
                            onClick={() => { guardarPerfil("Bancaria"); }}
                        >
                            <i className="bi bi-check2-circle me-2"></i>
                            Guardar info Bancaria
                        </button>
                    )}

                    {/* INFO BANCARIA CONFIRMADA */}
                    {usuario?.infoBancariaCompleta && (
                        <button className="btn btn-success" onClick={() => {}}>
                            <i className="bi bi-patch-check-fill me-2"></i>
                            Info bancaria confirmada
                        </button>
                    )}
                </div>
            </div>


            {/* TIP  */}
            <div className="alert mb-4" style={{ backgroundColor: "var(--color-bg-accent-subtle)", border: "1px solid var(--azul-cielo)", color: "var(--color-text-primary)" }}>
                <div className="d-flex flex-column gap-1">
                    <span style={{ color: "var(--color-text-primary)", fontWeight: 500 }}>Esta información es obligatoria para ser vendedor, porque a esta cuenta te consignaremos los pagos de los servicios que vendas en la plataforma.</span>
                </div>
            </div>


            <div className="row g-3">
                {/* BANCO */}
                <div className="col-12 col-md-6">
                    <div className="form-floating">
                        <select
                            className="form-select"
                            value={infoBanco.banco}
                            onChange={(e) => cambiarCampoBanco("banco", e.target.value)}
                            disabled={usuario?.infoBancariaCompleta === true}
                        >
                            <option value="">Seleccione un banco</option>
                            {!bancos
                                ? null
                                : bancos.map((item, idx) => (
                                        <option key={idx} value={item.banco}>
                                            {item.banco}
                                        </option>
                                    ))}
                        </select>
                        <label>Banco</label>
                    </div>
                </div>

                {/* TIPO DE CUENTA */}
                {infoBanco.banco !== "Nequi" && infoBanco.banco !== "Daviplata" && (
                    <div className="col-12 col-md-6">
                        <div className="form-floating">
                            <select
                                className="form-select"
                                value={infoBanco.tipoCuenta}
                                onChange={(e) => cambiarCampoBanco("tipoCuenta", e.target.value)}
                                disabled={usuario?.infoBancariaCompleta === true}
                            >
                                <option value="Ahorros">Ahorros</option>
                                <option value="Corriente">Corriente</option>
                                <option value="Otro">Otro</option>
                            </select>
                            <label>Tipo de cuenta</label>
                        </div>
                    </div>
                )}

                {/* NÚMERO DE CUENTA / CELULAR */}
                <div className="col-12 col-md-6">
                    <div className="form-floating">
                        <input
                            type="text"
                            className="form-control"
                            value={infoBanco.numeroCuenta}
                            onChange={(e) => cambiarCampoBanco("numeroCuenta", e.target.value)}
                            placeholder={infoBanco.banco === "Nequi" || infoBanco.banco === "Daviplata" ? "Número de celular" : "Número de cuenta"}
                            readOnly={usuario?.infoBancariaCompleta === true}
                        />
                        <label>{infoBanco.banco === "Nequi" || infoBanco.banco === "Daviplata" ? "Número de celular" : "Número de cuenta"}</label>
                    </div>
                </div>

                {/* NOMBRE DEL TITULAR */}
                <div className="col-12 col-md-6">
                    <div className="form-floating">
                        <input
                            type="text"
                            className="form-control"
                            value={infoBanco.nombreTitular}
                            onChange={(e) => cambiarCampoBanco("nombreTitular", e.target.value)}
                            placeholder="Nombre del titular"
                            readOnly={usuario?.infoBancariaCompleta === true}
                        />
                        <label>Nombre del titular</label>
                    </div>
                </div>

                {/* IDENTIFICACIÓN DEL TITULAR */}
                <div className="col-12 col-md-6">
                    <div className="form-floating">
                        <input
                            type="text"
                            className="form-control"
                            value={infoBanco.identificacionTitular}
                            onChange={(e) => cambiarCampoBanco("identificacionTitular", e.target.value)}
                            placeholder="Identificación del titular"
                            readOnly={usuario?.infoBancariaCompleta === true}
                        />
                        <label>Identificación del titular</label>
                    </div>
                </div>
            </div>


            {/* CONFIRMAR INFORMACIÓN PROFESIONAL */}
            {usuario?.perfilProfesional?.completo ? null : (
                <ModalConfirmarInfoPersonal cualInfo={"Bancaria"} datos={infoBanco} idUsuario={usuario.idUsuario} />
            )}


            <hr className="my-4" />
        </>
    );
}

export default InfoBancaria;